import React from "react";
import MaskedInput from "react-text-mask";

interface MaskedInputProps {
  inputRef: (element: HTMLInputElement | null) => void;
  [key: string]: any;
}

const CuiInput: React.FC<MaskedInputProps> = ({ inputRef, ...other }) => {
  return (
    <MaskedInput
      {...other}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={() => {
        let mask = [
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          "-",
          /\d/,
        ];

        return mask;
      }}
      placeholderChar={"_"}
    />
  );
};

export default CuiInput;
